import { mode } from '@/helpers/enum';
import { requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';

export default {
  requestObjectKey: state => state.mainRequest.objectKey,
  isNewMode: state => state.mainRequest.mode === mode.new && !state.mainRequest.objectKey,
  isEditMode: state => state.mainRequest.mode === mode.update,
  isViewMode: state => state.mainRequest.mode === mode.view,
  isNotCompleted: state => state.mainRequest.statusId === requestStatusEnum.inComplete,
  isRequestUnderAudit: (state) => {
    const auditStatuses = [requestStatusEnum.underAudit, requestStatusEnum.returnedToAudit];
    return auditStatuses.includes(state.mainRequest.statusId);
  },
};
